import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=70eb7840&scoped=true"
import script from "./RatingCard.vue?vue&type=script&lang=js"
export * from "./RatingCard.vue?vue&type=script&lang=js"
import style0 from "./RatingCard.vue?vue&type=style&index=0&id=70eb7840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb7840",
  null
  
)

export default component.exports